import { environment } from '../../environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class ApplicationConfig {
  public static readonly PRIMARY_COLOR: string = '#435A99';
  public static readonly SECONDARY_COLOR: string = '#faa61a';

  public readonly DEFAULT_PRIMARY_COLOR: string = '#6A7788';
  public readonly DEFAULT_PRIMARY_TEXT_COLOR: string = '#ffffff';
  public readonly DEFAULT_SECONDARY_COLOR: string = '#faa61a';
  public readonly DEFAULT_SECONDARY_TEXT_COLOR: string = '#ffffff';
  public readonly DEFAULT_FONT: string = 'Roboto';
  public readonly DEFAULT_TEXT_COLOR: string = '#1c1c1c';
  public readonly DEFAULT_TITLE_TEXT_COLOR: string = '#5D4037';
  public readonly DATE_FORMAT: string = 'dd/MM/yyyy';
  public readonly DATE_TIME_FORMAT: string = 'dd/MM/yyyy, HH:mm';
  public readonly PDF_ICON_URL: string = 'assets/images/file-extensions/pdf.png';
  public readonly DEFAULT_LOGO_URL: string = 'assets/company-logo.png';
  public readonly CHAPPS_ACCOUNT_LOGO_URL: string = 'assets/chapps-button.png';
  public readonly AVATAR_PLACEHOLDER: string = 'assets/images/avatar_placeholder.png';
  public readonly TEAM_PLACEHOLDER: string = 'assets/images/team_placeholder.svg';
  public readonly MAX_RESOLUTION_TO_SHOW_BACK_BUTTON: number =  1200;
  public readonly BACK_BUTTON_REGEXP_PAGES: string[] = [
    '^\\/issues\\/',
    '^\\/jobs\\/',
    '^\\/contacts\\/',
    '^\\/intervention-teams\\/',
  ];
  public readonly ORIGINAL_ISSUE_TAB: string = `OriginalIssueTab_${environment.environmentName}`;
  public readonly BUILDING_PLACEHOLDER_URL: string = 'assets/images/site_placeholder.svg';
}

